<template>
  <Card>
    <template v-slot:content>
      <div class="p-grid">
        <div class="p-col-12 p-md-6">
          <Skeleton v-if="loading" height="30px" />
          <h5 v-else>Bovinos na fazenda</h5>
        </div>
        <div class="p-col-12 p-md-6">
          <Skeleton v-if="loading" height="30px" />
          <Dropdown
            v-else
            v-model="query.farmId"
            :options="farms"
            @change="getData()"
            optionLabel="name"
            optionValue="id"
            style="width: 100%"
          />
        </div>
        <div class="p-col-12 p-mt-5">
          <Skeleton v-if="loading" height="206px" />
          <Chart
            v-else
            ref="chart"
            type="pie"
            :data="chartData"
            :width="200"
            :height="200"
            :options="chartOptions"
          />
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Chart from 'primevue/chart';
import { ReportApi } from '../../../services/api';

const colors = {
  1: '#000', // Touro
  2: '#9A7A54', // Boi
  3: '#FFE600', // Vaca
  4: '#0085FF', // Bezerro
  5: '#FF0000', // Bezerra
};

export default {
  components: { Chart },
  data() {
    return {
      chartOptions: {},
      chartData: { labels: [], datasets: [] },
      query: { farmId: null },
      farms: [],
      loading: true,
    };
  },
  watch: {
    async farms(newValue, oldValue) {
      if (!oldValue.length && newValue.length) {
        this.query.farmId = this.farms?.[0]?.id || null;
        await this.getData();
      }
    },
  },
  methods: {
    async setFarms(farms) {
      if (!farms.length) {
        this.loading = false;
      }
      this.farms = farms;
    },
    async getData() {
      try {
        const results = await ReportApi.getBovinesByType(this.query);

        const originalCount = results.map((result) => result.count);
        const totalCount = originalCount.reduce((a, v) => a + v);
        const percentCount = originalCount.map((v) =>
          v > 0 ? Math.max((v / totalCount) * 100, 1) : 0
        );

        const labels = ['Touro', 'Boi', 'Vaca', 'Bezerro', 'Bezerra'];
        this.chartData = {
          labels,
          datasets: [
            {
              data: percentCount,
              backgroundColor: Object.values(colors),
            },
          ],
        };
        this.chartOptions = {
          responsive: true,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                boxWidth: 0,
                generateLabels() {
                  return [
                    {
                      text: `Total de Bovinos: ${totalCount}`,
                    },
                  ];
                },
              },
            },
            tooltip: {
              enabled: true,
              mode: 'nearest',
              callbacks: {
                label: function (tooltipItem) {
                  const value = originalCount[tooltipItem.dataIndex];
                  const label = labels[tooltipItem.dataIndex];
                  return `${label}: ${value}`;
                },
              },
            },
          },
        };
      } finally {
        this.loading = false;
      }

      this.$nextTick(() => {
        if (this.$refs.chart) {
          this.$refs.chart.reinit();
        }
      });
    },
  },
};
</script>

<style scoped>
div >>> .p-card-content {
  padding: 0;
}
div >>> canvas {
  max-height: 250px;
}
</style>
